import {
  Meta,
  BreadcrumbList,
  BreadcrumbItems,
  MainContent,
} from "@/components/index";
import { useMeta } from "@/hooks/useMeta";
export default function Course() {
  const { query } = useMeta();

  let name = query.university + "/" + query.major + "/" + query.course;
  return (
    <Meta
      title={`${query.course} page from ${query.university} `}
      description={`The page the shows the content of ${query.course} `}
      image="https://axed.vercel.app/favicon-512.png"
    >
      <BreadcrumbList>
        <BreadcrumbItems link={""} name={"Home"} />
        <BreadcrumbItems
          link={String(query.university)}
          name={String(query.university)}
        />
        <BreadcrumbItems
          link={String(query.university) + "/" + String(query.major)}
          name={String(query.major)}
        />
        <BreadcrumbItems
          current={true}
          link={String(query.course)}
          name={String(query.course)}
        />
      </BreadcrumbList>
      <MainContent query={name} link={"Homeworks"} search="Category" />
    </Meta>
  );
}
